/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type HttpResponse, HttpService } from '@dm/core';
import { type Observable } from 'rxjs';

export enum ErrorCode {
    busy = 1077949006,  // 升级上来后底层出现ccdb表不存在
    noData = 1077948996 // 升级上来后底层如果ccdb表存在但是表中没有数据
}

@Injectable()
export class QrcodeService {
    constructor(
        private http: HttpService,
    ) { }

    getFirstPoweronTime(): Observable<HttpResponse> {
        const rest = this.http.makeUrl('system.getFirstPoweronTime');
        return this.http.get(rest, { mask: true, doException: false });
    }
}
